// extracted by mini-css-extract-plugin
export default {"nav_container":"Nav_nav_container__px-n+","nav_title_wrapper":"Nav_nav_title_wrapper__KngHN","logo":"Nav_logo__xVoO3","nav_details":"Nav_nav_details__-TUc1"};